// extracted by mini-css-extract-plugin
export var attribution = "_at-4";
export var authorName = "_at-5";
export var quote = "_at-3";
export var testimonial = "_at-2";
export var trustedBy = "_at-0";
export var trustedByLabel = "_at-1";